<main>

    <div id="title">
        <h2 mat-dialog-title>{{titulo}}</h2>

    </div>

    <hr>

    <div id="mensaggem">
        <p  [innerHtml]="texto | safeHtml"></p>
        
    </div>

    <mat-dialog-actions>
        <button class="mat-raised-button"(click)="close()">Cancelar</button>
        <button class="mat-raised-button mat-primary"(click)="confirm()">Confirmar</button>
    </mat-dialog-actions>

</main>